(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("fjplayer", [], factory);
	else if(typeof exports === 'object')
		exports["fjplayer"] = factory();
	else
		root["fjplayer"] = factory();
})(self, function() {
return 